import React, { useState, useEffect } from 'react';
import { Grid, Box, Typography } from '@material-ui/core';
import CarouselImage from '../../../../../components/Carousel/Carousel';
import UpperColon from '../../../../../assets/UpperColon.svg';
import LowerColon from '../../../../../assets/LowerColon.svg';

function Management({ styles, data }) {
  const [founderInfo, setfounderInfo] = useState({});
  const [managementData, setManagementData] = useState([]);

  useEffect(() => {
    if (data.managements) {
      setfounderInfo(data.managements[0]);
      setManagementData(data.managements);
    }
  }, [data]);

  return (
    <Box>
      {data.managements ? (
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} className={styles.mgmentBorder}>
              {data.visionAndPhilosophy ? (
                <Box>
                  <Box className={styles.upperColonBox}>
                    <img
                      src={UpperColon}
                      alt={'UpperColon'}
                      className={styles.colonImg}
                    />
                  </Box>
                  <Box className={styles.topMargin}>
                    <Box className={styles.founderMsgContainer}>
                      <Box>
                        <Box className={styles.sectionSubTextNoWeight}>
                          {data.visionAndPhilosophy}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  {founderInfo ? (
                    <Box className={styles.founderDescription}>
                      <Box className={styles.founderImageContainer}>
                        <img
                          src={founderInfo.imageFullUrl}
                          alt={'FounderImage'}
                          className={styles.founderImage}
                        />
                      </Box>
                      <Box className={styles.founderNameRoleBox}>
                        <Typography
                          variant="body1"
                          className={styles.founderName}>
                          {founderInfo.name}
                        </Typography>
                        <Typography
                          variant="body1"
                          className={styles.founderRole}>
                          {founderInfo.role}
                        </Typography>
                      </Box>
                    </Box>
                  ) : null}
                  <Box className={styles.lowerColonBox}>
                    <img
                      src={LowerColon}
                      alt={'LowerColon'}
                      className={styles.colonImg}
                    />
                  </Box>
                </Box>
              ) : null}
            </Grid>
            <Grid item xs={12} className={styles.carouselContainer}>
              {managementData.length > 0 ? (
                <Box>
                  <CarouselImage data={managementData} />
                </Box>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      ) : null}
    </Box>
  );
}
export default Management;
